const accordionAction = () => {
  const contents = $(".accordeon__body--content"),
    titles = $(".accordeon__body--tab");
  titles.on("click", function() {
    let title = $(this);
    contents.filter(":visible").slideUp(function() {
      $(this)
        .prev(".accordeon__body--tab")
        .removeClass("is-opened");
    });

    let content = title.next(".accordeon__body--content");

    if (!content.is(":visible")) {
      content.slideDown(function() {
        title.addClass("is-opened");
      });
    }
  });
};
export default accordionAction;



// WEBPACK FOOTER //
// ./scripts/modules/accordeon.js